<template lang="pug">
.px-lg-15.py-8.px-3
  v-sheet.mx-auto(v-if="!loading", max-width="1080px")
    grid-container.align-center(
      v-if="content.text",
      cols="auto",
      cols-md="50% 50%",
      gap="32px",
      gap-md="80px"
    ) 
      div
        custom-title.mb-4 {{ content.title }}
        .text--secondary(v-html="content.text")
      img.page-home-about-img.rounded-sm(
        :src="files + content.img",
        :alt="content.title"
      )
  .py-10.d-flex.justify-center(v-else)
    v-progress-circular(size="50", color="primary", indeterminate)
</template>

<script>
import CustomTitle from "../shell/CustomTitle.vue";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    content() {
      return this.$rest(_config.mod).item;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod)
      .get({ save: (state, data) => (state.item = data) })
      .then(() => (this.loading = false));
  },
  components: {
    CustomTitle,
  },
};
</script>
